import { shuffle } from "../randomization";
import { CyclingBank } from "./cycling_bank";

export class ShuffledCyclingBank<T> extends CyclingBank<T> {
  constructor(bank: T[]) {
    super(shuffle(bank));
  }
}
